import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import qs from 'qs';
import { Alert } from 'reactstrap';

import ActiveErrors from '../../components/common/activeErrors';
import LoadingIndicator from '../../components/loadingIndicator';
import { resolveLocationEntryPoint, setLocationEntryPoint } from '../../actions/sessionActions';
import * as routes from '../../routes';
import { useAppDispatch, useAppSelector } from '../../store';

const LocationRedirector = () => {
	const dispatch = useAppDispatch();
	const location = useLocation();
	const routePrefix = useAppSelector((state: any) => state.config.instance.routePrefix);

	const [isLoading, setIsLoading] = useState(true);
	const [alertMessage, setAlertMessage] = useState('');

	useEffect(() => {
		const params = qs.parse(location.search, { ignoreQueryPrefix: true }) as {
			refType?: string;
			refValue?: string;
		};

		const refType = params.refType?.trim();
		const refValue = params.refValue?.trim();

		if (!refType || !refValue) {
			setAlertMessage('Please provide refType and refValue (pmsid) for the location entry point.');
			setIsLoading(false);
			return;
		}

		dispatch(resolveLocationEntryPoint(refType, refValue))
			.then((response: any) => {
				if (response?.error) {
					setAlertMessage('Unable to resolve location from the provided site identity.');
					setIsLoading(false);
					return;
				}

				const data = response?.payload?.data;
				if (!data?.siteId) {
					setAlertMessage('Location lookup did not return a practice site.');
					setIsLoading(false);
					return;
				}

				dispatch(setLocationEntryPoint({
					siteId: data.siteId,
					pmsId: data.pmsId,
					siteName: data.siteName,
					patientPoolUniqueToken: data.patientPoolUniqueToken || null,
					patientPoolDisplayName: data.patientPoolDisplayName || null,
					patientPoolPrefix: data.patientPoolPrefix || null,
					isPatientPoolLocked: !!data.patientPoolUniqueToken,
				}));

				dispatch(routes.patientSearch(routePrefix));
			})
			.catch(() => {
				setAlertMessage('Unable to resolve location from the provided site identity.');
				setIsLoading(false);
			});
	}, [dispatch, location.search, routePrefix]);

	if (isLoading) {
		return <LoadingIndicator loadingMessage="Resolving location..." />;
	}

	return (
		<div>
			<ActiveErrors />
			{alertMessage && (
				<Alert className="text-center" color="warning">
					{alertMessage}
				</Alert>
			)}
		</div>
	);
};

export default LocationRedirector;
